<template>
    <div>
      <div id="div-journey-report-with-loading" class="vs-con-loading__container" style="min-height: 25px;">
        <div v-if="!reportData || !reportData.data || reportData.data.length === 0" class="items-center">
          No Journey Report Data Found
        </div>
        <div v-else>
            <div class="mb-base">
                <basic-bar :reportData="reportData" />
            </div>
            <div>
                <table-data :reportData="reportData" />
            </div>
        </div>
      </div>
    </div>
</template>

<script>
import BasicBar from './BasicBar.vue';
import TableData from './TableData.vue';

export default {
  data() {
      return {
        reportData: {}
      }
  },
  components: { BasicBar, TableData },
  computed: {
    orgData() {
      return this.$store.state.organization.orgData;
    },
  },
  watch: {
    orgData() {
      this.fetchJourneyReport();
    }
  },
  methods: {
    async fetchJourneyReport() {
      if(this.orgData && this.orgData._id) {
        this.$vs.loading({
          container: '#div-journey-report-with-loading',
          scale: 0.5
        });
        this.reportData = await this.$store.dispatch('journey/fetchJourneyReport', this.orgData._id);
        this.$vs.loading.close('#div-journey-report-with-loading > .con-vs-loading');
        this.$forceUpdate();
      }
    }
  },
  mounted() {
    this.fetchJourneyReport();
  }
}
</script>